export default __webpack_public_path__ + "static/media/email.c3f03c9e.svg";